import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemCategoriesDelete: {},
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemCategoriesDeleteSlice = createSlice({
  name: "itemCategoriesDeleteSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showDeleteItemCategoriesDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemCategoriesDelete: action.payload,
      };
    },
    closeDeleteItemCategoriesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showDeleteItemCategoriesDialog,
  closeDeleteItemCategoriesDialog,
  showLoading,
  hideLoading
} = itemCategoriesDeleteSlice.actions;

export default itemCategoriesDeleteSlice.reducer;
